import React, { useContext, useEffect, useRef } from 'react';
import { getLabel } from '../../data/labels';
import { BetslipContext } from '../betslip/BetslipConf';
import { getConfiguration } from '../utils';

function BetslipLoader(props) {
	const betslipContext = useContext(BetslipContext);
	const betslipData = betslipContext.getBetslipData();
	const loaderData = betslipContext.getLoaderData();
	const conf = getConfiguration();
	const showCounterLive = !conf.hcb;
	// const loaderData = {
	// 	type :"success",
	// 	idTicket : 'DF123123123123123',
	// 	successCallback : function() {}
	// };
	
	const id = loaderData.type + "-loader";
	
	const couponKey = betslipData.selectedCoupon;
	const coupon = betslipData.coupons[couponKey];
	const isSinglebets = coupon.selectedContainer === 'singlebets';
	let eventSingle = null;
	if (isSinglebets) {
		if(loaderData.type === 'prematch' || loaderData.type === 'live') {
			eventSingle = coupon.selections[0];
		}
	}
	
	let timeoutId = useRef(null);
	useEffect(() => {
        function handleHideAll() {
			clearTimeout(timeoutId.current);
        }

		if (loaderData.type  === 'hideAll') {
			handleHideAll();
		} else {
			if (loaderData.type  === 'success') {
                let millis = 2500;
                if (window.appConfig){
                	if (window.appConfig.SELF_CASHIER || window.appConfig.TERMINAL_AGENCY) {
                		millis = 50;
                	}
                }
				timeoutId.current = setTimeout(() =>{
					if (typeof(loaderData.successCallback === 'function')) {
						loaderData.successCallback();					
					}
				}, millis);
			}
		}

        //Handling hideAll on component unmount
        return () => {
            handleHideAll();
        };
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loaderData.type]);

    if (loaderData.type === 'hideAll') {
        return null;
    }

    return (
        <div id={id} className={"loader-cart"}>
            {(loaderData.type === 'prematch' || (loaderData.type === 'live' && !showCounterLive) || loaderData.type === 'live_end_timer') && 
                <>
                    <div className="bouncing-cart-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div> 
                    <div className="loader-label"> 
                        {eventSingle != null ?
                            `${getLabel('carrello.bet_in_progress_part1')} ${eventSingle.descEvent} ${getLabel('carrello.bet_in_progress_part2')} ${eventSingle.bets[0].descBet} - ${eventSingle.bets[0].descDraw} ${getLabel('carrello.bet_in_progress_part3')}`
                            :
                            getLabel('carrello.bet_in_progress')
                        } 
                    </div>
                </>
            }
            {(loaderData.type === 'retry-status-transaction') && 
                <>
                    <div className="bouncing-cart-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div> 
                    <div className="loader-label"> 
                        [{loaderData.frontendTransactionId}] Attendere: giocata in corso. Non chiudere il browser.
                    </div>
                </>
            }
            {loaderData.type === 'live' && showCounterLive &&
                <>
                    <div className="bouncing-cart-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="loader-label"> 
                        {eventSingle != null ?
                            `${getLabel('carrello.bet_in_n_seconds_part1')} ${eventSingle.descEvent} ${getLabel('carrello.bet_in_n_seconds_part2')} ${eventSingle.bets[0].descBet} - ${eventSingle.bets[0].descDraw} ${getLabel('carrello.bet_in_n_seconds_part3')} ${loaderData.remainingSeconds}...`
                            :
                            `${getLabel('carrello.bet_in_n_seconds')} ${loaderData.remainingSeconds}...`
                        }
                    </div>
                </>
            }
            {loaderData.type === 'acceptance' && 
                <>
                    <div className="bouncing-cart-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div> 
                    <div className="loader-label"> {`${getLabel('carrello.approval_pending')} ${loaderData.remainingSeconds}...`}</div>
                </>
            }
            {loaderData.type === 'success' && 
                <div className="loader-cart-success">
                    <div className="animated-checkmark-container">
                        <svg className="animated-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"></circle>
                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
                        </svg>
                    </div>
                    <div className="loader-label">
                        {getLabel('carrello.ticket_sold')} <br/>  {loaderData.idTicket} 
                    </div>
                </div>
            }
        </div>
    );
}

export default BetslipLoader;
